import InstantMessagePayload from 'owa-service/lib/contract/InstantMessagePayload';
import { addOrUpdatePresence } from '../../actions/presenceActions';
import updateSelfPresence from '../../presenceManager/updateSelfPresence';
import isSignedIn from '../../presenceManager/isSignedIn';

export default function onPresenceChanged(notification: InstantMessagePayload) {
    // Ignore any notifications received before sign-in has succeeded
    if (!isSignedIn()) {
        return;
    }

    if (notification.PayloadType == 'UpdateUserPresence') {
        // Update the presence info about the current user
        updateSelfPresence(notification.NewUserPresence);
        return;
    }

    if (!notification.UserPresenceChanges) {
        return;
    }

    notification.UserPresenceChanges.forEach(presenceChange => {
        addOrUpdatePresence(presenceChange.SipUri, presenceChange.Presence);
    });
}
